import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type { GetNotificationListResponse, NotificationListSort } from 'viewup-api/v2';

export const DEFAULT_NOTIFICATION_PAGE = 1;
export const DEFAULT_NOTIFICATION_LIMIT = 20;

export interface GetNotificationReq {
  limit?: number;
  page?: number;
  sort?: NotificationListSort;
}

export const getNotification = async (
  query?: GetNotificationReq,
): Promise<GetNotificationListResponse> => {
  const response = await serviceApi.notification.getNotificationList(
    withServiceRequestDefaults({
      page: query?.page ?? DEFAULT_NOTIFICATION_PAGE,
      limit: query?.limit ?? DEFAULT_NOTIFICATION_LIMIT,
      sort: query?.sort,
    }),
  );

  return response.data;
};

/**
 * 무한 스크롤 다음 페이지 번호. 더 가져올 게 없으면 null.
 *
 * v2 meta에는 총 페이지 수가 없어 "누적 로드 건수 >= totalCount"로 종료를 판단한다.
 * 다만 그 조건만으로는 부족하다 — 읽음 처리 invalidate 등으로 서버의 totalCount와 페이지
 * 윈도우가 어긋나 마지막 페이지가 빈 배열로 오면 종료 조건에 영영 닿지 못하고 page 번호만
 * 증가하며 무한 재요청한다. 그래서 빈 페이지를 종료 신호로 함께 본다.
 */
export const getNotificationNextPageParam = (
  lastPage: GetNotificationListResponse,
  allPages: GetNotificationListResponse[],
): number | null => {
  if (lastPage.data.length === 0) return null;

  const loadedCount = allPages.reduce((count, page) => count + page.data.length, 0);
  if (loadedCount >= lastPage.meta.totalCount) return null;

  return allPages.length + 1;
};
